module.exports = __webpack_public_path__ + "files/sql-server-2008-database-development.a2db5305.pdf";